// extracted by mini-css-extract-plugin
export default {"container":"style_container__CEpWV","inliine_content":"style_inliine_content__SVUn3","swiper":"style_swiper__bV7X2","swiper_slide":"style_swiper_slide__iH3ss"};